module.exports = __webpack_public_path__ + "img/cost-icon__camas_balinesas.1b9ef3a2.svg";